<template>
    <Overlay :show="showLoading">
        <b-card no-body :border-variant="borderVariant">
            <div class="card-header">
                <div class="w-100">
                    <b-card-title id="popover-button-1">{{ component.title }}</b-card-title>
                </div>
                <div v-if="parents.length > 0">
                    <b-icon-folder/>
                    <span class="text-less-muted" style="font-size: 0.9rem; padding-left: 4px;">{{ header }}</span>
                </div>
            </div>
            <div class="pl-1 pr-1">
                <b-form-group
                    :label="scipNameLabel"
                    label-for="scipName"
                >
                    <b-form-input
                        id="scipName"
                        v-model="name"
                        @input="emit"
                    />
                </b-form-group>
                <b-form-group
                    :label="scipNumberLabel"
                    label-for="scipId"
                >
                    <b-form-input
                        id="scipId"
                        class="input-bg-warning"
                        v-model="id"
                        :state="idErrors.length > 0 ? false : null"
                        @input="emit"
                    />
                    <small class="text-danger" v-for="error in idErrors">{{ error }}</small>
                </b-form-group>
            </div>
        </b-card>
    </Overlay>
</template>

<script>
import ReplyTabProductSection from "@core/mixins/ui/reply-tab-product-section";
import {BFormInput, BFormGroup, BCard, BCardTitle, BIconFolder} from 'bootstrap-vue'
import Overlay from "@core/components/common/Overlay.vue";

export default {
    mixins: [ReplyTabProductSection],
    components: {Overlay, BFormInput, BFormGroup, BCard, BCardTitle, BIconFolder},
    props: {
        component: {
            required: true,
        },
        parents: {
            required: true
        }
    },
    data() {
        return {
            name: this.component.scipInformation.name,
            id: this.component.scipInformation.id,
            idErrors: [],
            showLoading: false
        };
    },
    methods: {
        emit() {
            this.$emit('input', this.component, {
                name: this.name,
                id: this.id
            }, () => this.showLoading = true, (errors) => {
                this.showLoading = false;

                if (errors) {
                    if (errors.id && errors.id.length > 0) {
                        this.idErrors = errors.id;
                    }
                } else {
                    this.idErrors = [];
                }
            });

            this.emitValidity();
        },

        isValid() {
            return typeof this.name === 'string' && this.name.length > 0;
        },

        emitValidity() {
            this.$emit('validityChanged', this.isValid());
        },
    },
    computed: {
        header() {
            let titles = this.parents.map(c => c.title);
            titles.pop();
            return titles.join(' / ');
        },
        borderVariant() {
            return this.isValid() ? 'success' : 'default';
        }
    },
    created() {
        this.emitValidity();
    },
    watch: {
        component(p) {
            this.name = this.component.scipInformation.name;
            this.id = this.component.scipInformation.id;

            this.emitValidity();
        }
    }
}
</script>
